import { httpClient } from '@connectors/HttpClient'

import type { Subscription } from '../types'

export const SubscriptionService = {
    listbySchools: async (status?: 'ACTIVE' | 'INACTIVE'): Promise<Subscription[]> => {
        const params = new URLSearchParams()
        if (status) {
            params.append('status', status)
        }

        const response = await httpClient.axios.get(`/admin/subscriptions/schools?${params.toString()}`)
        return response.data
    },
    updateSubscriptionStatus: async (): Promise<any> => {
        const response = await httpClient.axios.put(`/admin/subscriptions/update-status`)
        return response.data
    }
}
